export const getStoredUser = () => {
  const storedUser = localStorage.getItem('user') || sessionStorage.getItem('user');
  if (!storedUser) return {};

  try {
    return JSON.parse(storedUser);
  } catch (error) {
    console.error('Error parsing stored user data:', error);
    return {};
  }
};

export const getPositiveUserId = (user) => {
  const userId = Number(user?.id);
  return Number.isInteger(userId) && userId > 0 ? userId : null;
};

const ADMIN_ACCESS_ROLES = ['ROLE_ADMIN', 'ROLE_ASSISTANT', 'ROLE_LEAD'];

export const hasRoleAdmin = (user) => user?.roles?.includes('ROLE_ADMIN') || false;

export const hasAdminAccess = (user) => (
  ADMIN_ACCESS_ROLES.some((role) => user?.roles?.includes(role))
);
